import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import { SupplierPrice } from './SupplierPrice';
import { BuyerPrice } from './BuyerPrice';
import { useLocation } from 'react-router-dom';
import { RevxButton } from 'components/RevxButton';
import { useHistory } from 'react-router-dom';
import React, { useState } from 'react';
import { ArrowLeftIcon } from 'components/Icons';
import { useMount } from 'ahooks';
import skuService from 'services/skuService';
import { useAppDispatch } from 'app/hooks';

export interface CommonFooterProps {
  onSave: () => void;
}

export interface PriceProps {
  skuId: number;
  header: () => React.ReactElement;
  isPart: boolean;
  footer: (props: CommonFooterProps) => React.ReactElement;
}

const UnitPrice = () => {
  const [isPart, setIsPart] = useState<boolean>(false);
  const { t } = useTranslation();
  const urlParams = new URLSearchParams(useLocation().search);
  const skuId = Number(urlParams.get('skuId'));
  const name = urlParams.get('name');
  const currentPage = urlParams.get('page') || 1;
  const history = useHistory();
  const dispatch = useAppDispatch();

  useMount(async () => {
    setIsPart(await skuService.getUnitPricePart(skuId));
  });

  const backHandler = () => {
    dispatch.sku.setDefaultPage({
      currentPage: +currentPage,
      pageSize: 20,
    });
    history.goBack();
  };

  const Header = () => {
    return (
      <div className="ant-page-header-heading">
        <div className="ant-page-header-heading-left">
          <div className="back-icon click" onClick={backHandler}>
            <ArrowLeftIcon />
          </div>
          <div className="ant-page-header-heading-title">{name}</div>
        </div>
      </div>
    );
  };

  const Footer = ({ onSave }: CommonFooterProps) => {
    return (
      <footer>
        {/*<RevxButton onClick={backHandler} brandGreen>
          {t('common.cancel')}
        </RevxButton>*/}
        <RevxButton onClick={onSave} brandGreen className="mb-24">
          {t('common.save')}
        </RevxButton>
      </footer>
    );
  };
  const componentProps = {
    skuId,
    header: Header,
    isPart,
    footer: Footer,
  };

  return (
    <Tabs
      defaultActiveKey="1"
      tabPosition="left"
      destroyInactiveTabPane={true}
      style={{ height: '100%', backgroundColor: 'white', paddingTop: 8 }}
    >
      <Tabs.TabPane tab={t('platform.sku.unitPrice.supplierPrice')} key="1">
        <SupplierPrice {...componentProps} />
      </Tabs.TabPane>
      <Tabs.TabPane tab={t('platform.sku.unitPrice.buyerPrice')} key="2">
        <BuyerPrice {...componentProps} />
      </Tabs.TabPane>
    </Tabs>
  );
};

export default UnitPrice;
